import React from 'react';
import { Brain as LucideBrain } from 'lucide-react';

const Brain = props => (
  <LucideBrain {...props} />
);

export default Brain;
